import _toConsumableArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import React from "react";
var __jsx = React.createElement;
import { faEllipsisVertical } from "@fortawesome/pro-regular-svg-icons";
import { getFormattedDate, getDaysUntilDue } from "../../utils";
import AwesomeIcon from "../AwesomeIcon";
import DropdownMenu from "../common/DropdownMenu";
import resolveReminder from "./services/resolveReminder";
import { differenceInDays } from "date-fns";
import { t } from "i18next";
import useSingleWorkspace from "../WorkspaceManagement/services/useSingleWorkspace";
import { useMemo } from "react";
var isReminderPassed = function isReminderPassed(remindAfter) {
  var today = new Date();
  today.setHours(0, 0, 0, 0);
  var reminderDate = new Date(remindAfter);
  reminderDate.setHours(0, 0, 0, 0);
  var daysRemaining = differenceInDays(reminderDate, today);
  return daysRemaining < 0;
};
export var PatientReminderItem = function PatientReminderItem(_ref) {
  var patient_uid = _ref.patient_uid,
    reminder = _ref.reminder,
    showReminderEditModal = _ref.showReminderEditModal,
    refetchReminders = _ref.refetchReminders,
    workspaceId = _ref.workspaceId;
  var context = reminder.context,
    remind_after = reminder.remind_after;
  var reminderDate = getFormattedDate(remind_after, "PP");
  var hasReminderPassed = isReminderPassed(remind_after);
  var isReminderResolved = reminder.resolved;

  // Fetch workspace users to get username from user ID
  var _useSingleWorkspace = useSingleWorkspace({
      isOpen: !!workspaceId,
      id: workspaceId
    }),
    workspaceData = _useSingleWorkspace.data;

  // Get user ID from reminder
  var userId = reminder.owned_by || null;

  // Find username from user ID
  var username = useMemo(function () {
    if (!userId || !workspaceData || !workspaceData.users) {
      // Fallback to task_owner if no user ID or users not loaded
      return reminder.task_owner || "";
    }
    var user = workspaceData.users.find(function (u) {
      return u.id === userId;
    });
    return (user === null || user === void 0 ? void 0 : user.name) || reminder.task_owner || "";
  }, [userId, workspaceData, reminder.task_owner]);
  var reminderOptions = [{
    name: /*#__PURE__*/React.createElement("div", {
      className: "p-2"
    }, t("edit_key")),
    onClick: function onClick() {
      return showReminderEditModal(reminder);
    }
  }].concat(_toConsumableArray(isReminderResolved ? [] : [{
    name: /*#__PURE__*/React.createElement("div", {
      className: "p-2"
    }, t("mark_resolved")),
    onClick: function onClick() {
      return handleResolverReminder();
    }
  }]));
  var handleResolverReminder = function handleResolverReminder() {
    resolveReminder(patient_uid, reminder.id).then(function (res) {
      refetchReminders();
    });
  };
  var _getDaysUntilDue = getDaysUntilDue(remind_after),
    text = _getDaysUntilDue.text,
    daysRemaining = _getDaysUntilDue.daysRemaining;
  var reminderTag = isReminderResolved ? /*#__PURE__*/React.createElement("div", {
    className: "px-3 py-2 text-[14px] text-gray-200 rounded-full bg-green-500"
  }, t("done")) : hasReminderPassed ? /*#__PURE__*/React.createElement("div", {
    className: "px-3 py-2 text-[14px] text-gray-200 rounded-full bg-red-500"
  }, t("overdue")) : /*#__PURE__*/React.createElement("div", {
    className: "px-3 py-1 text-[14px] text-gray-200 rounded-full flex items-center w-fit ".concat(daysRemaining > 7 ? "bg-gray-500" : "bg-amber-600")
  }, /*#__PURE__*/React.createElement("span", null, text));
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col p-4 mb-3 border-[1px] border-gray-700 dark:border-gray-700 bg-gray-100 dark:bg-transparent rounded-md group p-[16px]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header flex justify-between items-center mb-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-left"
  }, /*#__PURE__*/React.createElement("div", {
    className: "content dark:text-white text-gray-900 text-left ".concat(isReminderResolved ? "line-through" : "")
  }, context)), /*#__PURE__*/React.createElement("div", {
    className: "header-right flex items-center gap-4"
  }, reminderTag, /*#__PURE__*/React.createElement("div", {
    className: "ml-auto"
  }, /*#__PURE__*/React.createElement(DropdownMenu, {
    options: reminderOptions,
    menuItemClassName: "z-50 !w-[200px] text-[14px] text-left px-2 py-2 dark:text-gray-900",
    buttonClassName: "border-none",
    Icon: function Icon(_ref2) {
      var open = _ref2.open;
      return /*#__PURE__*/React.createElement(AwesomeIcon, {
        name: faEllipsisVertical,
        size: "lg",
        className: "dark:text-gray-100 text-gray-900"
      });
    }
  })))), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between gap-2 text-[12px]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-gray-800 dark:text-gray-400"
  }, t("label.owned_by"), ": ", username), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    className: "text-gray-800 dark:text-gray-400"
  }, t("due_on"), " ", reminderDate))));
};